// Edit Account Email
export const EDIT_ACCOUNT_EMAIL_REQUEST = 'EDIT_ACCOUNT_EMAIL_REQUEST';
export const EDIT_ACCOUNT_EMAIL_DONE = 'EDIT_ACCOUNT_EMAIL_DONE';
export const EDIT_ACCOUNT_EMAIL_FAILED = 'EDIT_ACCOUNT_EMAIL_FAILED';